<!-- 检查计划列表 -->
<template>
  <div class="nx-list-page check-inspection-plan-list">
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      :beforeOpen="beforeOpen"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @selection-change="selectionChange"
    >
      <template slot="planCode" slot-scope="{ row }">
        <el-link type="primary" @click="handleViewPlan(row)">
          {{ row.planCode }}
        </el-link>
      </template>

      <template slot="checkFrequency" slot-scope="{ row }">
        {{ getCheckFrequencyText(row.checkFrequency) }}
      </template>

      <template slot="lastCheckTime" slot-scope="{ row }">
        {{ formatDate(row.lastCheckTime) }}
      </template>

      <template slot="nextCheckDate" slot-scope="{ row }">
        {{ formatDate(row.nextCheckDate) }}
      </template>

      <template slot="planStatus" slot-scope="{ row }">
        <matrix-tag
          v-if="row.planStatus === 1"
          color="#166534"
          text="启用"
        />
        <matrix-tag
          v-else
          color="#64748b"
          text="禁用"
        />
      </template>

      <template slot="menuLeft">
        <div class="toolbar-stats-row">
          <div class="toolbar-stats-row__actions">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-plus"
              @click="handleCreatePlan"
            >
              新建计划
            </el-button>
            <el-button
              type="success"
              size="small"
              icon="el-icon-check"
              :disabled="selectedRows.length === 0"
              @click="handleBatchEnable"
            >
              批量启用
            </el-button>
            <el-button
              type="warning"
              size="small"
              icon="el-icon-close"
              :disabled="selectedRows.length === 0"
              @click="handleBatchDisable"
            >
              批量禁用
            </el-button>
            <el-button
              type="primary"
              size="small"
              icon="el-icon-download"
              :loading="exportLoading"
              @click="handleExport"
            >
              导出
            </el-button>
          </div>
          <div class="toolbar-stats-row__stats">
            <div
              v-for="(item, index) in statisticsList"
              :key="item.label"
              class="toolbar-stat"
              :class="'toolbar-stat--' + index"
            >
              <span class="toolbar-stat__label">{{ item.label }}</span>
              <span
                class="toolbar-stat__value"
                :style="{ color: item.color }"
              >{{ item.value }}</span>
            </div>
          </div>
        </div>
      </template>

      <template #menu="{ size, row }">
        <el-button
          type="text"
          :size="size"
          icon="el-icon-view"
          @click="handleViewPlan(row)"
        >
          查看
        </el-button>
        <el-button
          type="text"
          :size="size"
          icon="el-icon-edit"
          @click="handleEditPlan(row)"
        >
          编辑
        </el-button>
        <el-button
          type="text"
          :size="size"
          :icon="row.planStatus === 1 ? 'el-icon-close' : 'el-icon-check'"
          :style="{ color: row.planStatus === 1 ? '#f56c6c' : '#67c23a' }"
          @click="handleToggleStatus(row)"
        >
          {{ row.planStatus === 1 ? "禁用" : "启用" }}
        </el-button>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import {
  getList,
  getCheckPlanDetail,
  addCheckPlan,
  updateCheckPlan,
  deleteCheckPlan,
  getCheckPlanStats,
  updateStatusBatch,
  exportExcel,
} from "./api";
import { formatDateTime as utilFormatDate } from "@/util/date";
import { downloadXls } from "@/util/util";
import matrixTag from "@/components/matrix/matrix-tag.vue";

export default {
  name: "check-inspection-plan-list",
  mixins: [crudMixins],
  components: {
    matrixTag,
  },
  data() {
    return {
      apiConfig: {
        getList: getList,
        add: addCheckPlan,
        update: updateCheckPlan,
        remove: deleteCheckPlan,
      },
      defaultParams: {
        businessType: "check-plan",
      },
      exportLoading: false,
      selectedRows: [],
      statisticsList: [
        {
          label: "计划总数",
          value: 0,
          color: "#374151",
        },
        {
          label: "进行中",
          value: 0,
          color: "#2563eb",
        },
        {
          label: "已完成",
          value: 0,
          color: "#059669",
        },
      ],
      option: {
        ...this.$store.state.publicOption,
        menu: true,
        menuWidth: 200,
        addBtn: false,
        delBtn: true,
        editBtn: false,
        viewBtn: false,
        selection: true,
        selectionFixed: false,
        column: [
          {
            label: "计划编号",
            prop: "planCode",
            overHidden: true,
            search: true,
            searchLabelWidth: 100,
            searchSpan: 6,
            searchPlaceholder: "请输入计划编号",
            slot: true,
            width: 180,
          },
          {
            label: "计划名称",
            prop: "planName",
            overHidden: true,
            search: true,
            searchLabelWidth: 100,
            searchSpan: 6,
            searchPlaceholder: "请输入计划名称",
            width: 180,
          },
          {
            label: "检查类型",
            prop: "checkType",
            type: "select",
            search: true,
            hide: false,
            showColumn: true,
            dicUrl: "/api/produce/safey-type/select/querySafeyType?safeyType=1",
            props: {
              label: "typeName",
              value: "typeCode",
            },
            minWidth: 100,
          },
          {
            label: "责任部门",
            prop: "responsibleDeptName",
            overHidden: true,
            search: false,
            searchSpan: 6,
            searchLabelWidth: 120,
            searchPlaceholder: "请输入责任部门",
            width: 120,
          },
          {
            label: "负责人",
            prop: "responsiblePersonId",
            type: "select",
            search: true,
            hide: true,
            searchSpan: 6,
            searchLabelWidth: 120,
            searchPlaceholder: "请选择负责人",
            remote: true,
            filterable: true,
            dicUrl: "/api/produce/blade-user/select/userList",
            props: { label: "name", value: "id" },
            width: 120,
          },
          {
            label: "负责人",
            prop: "responsiblePersonName",
            overHidden: true,
            search: false,
            searchSpan: 6,
            searchLabelWidth: 100,
            searchPlaceholder: "请输入负责人",
            width: 100,
          },
          {
            label: "执行频率",
            prop: "checkFrequency",
            type: "select",
            overHidden: true,
            search: true,
            searchSpan: 6,
            searchLabelWidth: 100,
            dataType: "number",
            dicData: [
              { label: "全部频率", value: "" },
              { label: "每日", value: 0 },
              { label: "每周", value: 1 },
              { label: "每月", value: 2 },
            ],
            slot: true,
            width: 100,
          },
          {
            label: "最近检查时间",
            prop: "lastCheckTime",
            type: "datetime",
            overHidden: true,
            search: false,
            slot: true,
            width: 180,
          },
          {
            label: "下次检查日期",
            prop: "nextCheckDate",
            type: "datetime",
            overHidden: true,
            search: false,
            slot: true,
            width: 180,
          },
          {
            label: "状态",
            prop: "planStatus",
            type: "select",
            overHidden: false,
            align: "center",
            className: "cell-plan-status",
            dataType: "number",
            dicData: [
              { label: "禁用", value: 0 },
              { label: "启用", value: 1 },
            ],
            slot: true,
            width: 100,
          },
          {
            label: "计划周期",
            prop: "planCycle",
            type: "select",
            overHidden: true,
            search: false,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=plan_cycle",
            dataType: "string",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            rules: [
              { required: true, message: "请选择计划周期", trigger: "change" },
            ],
            value: 0,
          },
        ],
      },
    };
  },
  mounted() {
    this.loadStats();
  },
  methods: {
    async loadStats() {
      try {
        const response = await getCheckPlanStats();
        if (response && response.data) {
          let planStatus = 0;
          let planCount = 0;
          let overdue = 0;
          response.data.data.forEach((val) => {
            if (val.executeStatus == 2) {
              overdue = val.planCount;
            } else if (val.executeStatus == 1) {
              planCount = val.planCount;
            } else if (val.executeStatus == 99) {
              planStatus = val.planCount;
            }
          });
          this.statisticsList = [
            {
              label: "计划总数",
              value: planStatus || 0,
              color: "#374151",
            },
            {
              label: "进行中",
              value: planCount || 0,
              color: "#2563eb",
            },
            {
              label: "已完成",
              value: overdue || 0,
              color: "#059669",
            },
          ];
        }
      } catch (error) {
        this.statisticsList = [
          {
            label: "计划总数",
            value: 0,
            color: "#374151",
          },
          {
            label: "进行中",
            value: 0,
            color: "#2563eb",
          },
          {
            label: "已完成",
            value: 0,
            color: "#059669",
          },
        ];
      }
    },

    selectionChange(selection) {
      this.selectedRows = selection;
    },

    async handleExport() {
      this.exportLoading = true;
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query));
        const res = await exportExcel(params);
        downloadXls(res.data, `检查计划列表_${Date.now()}.xlsx`);
        this.$message.success("导出成功");
      } catch (e) {
        console.warn(e);
        this.$message.error((e && e.message) || "导出失败");
      } finally {
        this.exportLoading = false;
      }
    },

    handleCreatePlan() {
      this.$router.push(
        "/dispatched-personnel-track/check-inspection-plan-list/create"
      );
    },

    handleBatchEnable() {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请先选择要启用的记录");
        return;
      }

      this.$confirm(
        `确定要启用选中的 ${this.selectedRows.length} 条记录吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          await this.batchUpdateStatus(1, "启用");
        })
        .catch(() => {
          this.$message.info("已取消操作");
        });
    },

    handleBatchDisable() {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请先选择要禁用的记录");
        return;
      }

      this.$confirm(
        `确定要禁用选中的 ${this.selectedRows.length} 条记录吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          await this.batchUpdateStatus(0, "禁用");
        })
        .catch(() => {
          this.$message.info("已取消操作");
        });
    },

    handleViewPlan(row) {
      this.$router.push({
        path: `/dispatched-personnel-track/check-inspection-plan-list/detail/${row.id}`,
      });
    },

    async handleEditPlan(row) {
      try {
        this.loading = true;
        const response = await getCheckPlanDetail(row.id);
        if (response && (response.code === 200 || response.success !== false)) {
          const detailData = response.data;
          this.$router.push({
            path: `/dispatched-personnel-track/check-inspection-plan-list/create`,
            query: {
              mode: "edit",
              id: row.id,
              data: JSON.stringify(detailData),
            },
          });
        } else {
          this.$message.error("获取计划详情失败，请重试");
        }
      } catch (error) {
        this.$message.error(
          "获取计划详情失败: " + (error.message || "网络错误")
        );
      } finally {
        this.loading = false;
      }
    },

    async batchUpdateStatus(status, actionName) {
      try {
        this.loading = true;
        const ids = this.selectedRows.map((row) => row.id).join(",");
        const response = await updateStatusBatch({
          ids: ids,
          status: status,
        });
        if (response && (response.code === 200 || response.success !== false)) {
          this.$message.success(`批量${actionName}成功`);

          this.selectedRows = [];
          if (this.$refs.crud && this.$refs.crud.$refs.table) {
            this.$refs.crud.$refs.table.clearSelection();
          }
          this.refreshChange();
          this.loadStats();
        } else {
          this.$message.error(
            response.message || response.msg || `批量${actionName}失败`
          );
        }
      } catch (error) {
        this.$message.error(
          `批量${actionName}失败: ${error.message || "网络错误"}`
        );
      } finally {
        this.loading = false;
      }
    },

    handleToggleStatus(row) {
      const newStatus = row.planStatus === 1 ? "禁用" : "启用";
      const status = newStatus === "启用" ? 1 : 0;

      this.$confirm(`确定要${newStatus}该检查计划吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            this.loading = true;
            const response = await updateStatusBatch({
              ids: row.id,
              status: status,
            });

            if (
              response &&
              (response.code === 200 || response.success !== false)
            ) {
              this.$message.success(`${newStatus}成功`);

              this.refreshChange();
              this.loadStats();
            } else {
              this.$message.error(
                response.message || response.msg || `${newStatus}失败`
              );
            }
          } catch (error) {
            this.$message.error(
              `${newStatus}失败: ${error.message || "网络错误"}`
            );
          } finally {
            this.loading = false;
          }
        })
        .catch(() => {
          this.$message.info("已取消操作");
        });
    },

    getCheckFrequencyText(frequency) {
      const textMap = {
        0: "每日",
        1: "每周",
        2: "每月",
      };
      return textMap[frequency] || frequency;
    },

    formatDate(date) {
      if (!date) return "-";
      return utilFormatDate(date) || "-";
    },
  },
};
</script>

<style lang="scss" scoped>
.check-inspection-plan-list {
  .toolbar-stats-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px 16px;
    width: 100%;
    box-sizing: border-box;
  }

  .toolbar-stats-row__actions {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    flex-shrink: 0;
  }

  .toolbar-stats-row__stats {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px 14px;
    margin-left: auto;
    flex: 1;
    justify-content: flex-end;
    min-width: 0;
  }

  .toolbar-stat {
    display: inline-flex;
    align-items: baseline;
    gap: 6px;
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 13px;
    line-height: 1.4;
    white-space: nowrap;
  }

  .toolbar-stat__label {
    color: #64748b;
  }

  .toolbar-stat__value {
    font-weight: 600;
    font-size: 15px;
  }

  .toolbar-stat--0 {
    background: rgba(55, 65, 81, 0.08);
  }

  .toolbar-stat--1 {
    background: rgba(37, 99, 235, 0.1);
  }

  .toolbar-stat--2 {
    background: rgba(5, 150, 105, 0.12);
  }
}

::v-deep td.cell-plan-status .cell {
  overflow: visible;
}
</style>
